<section class="blue-bg"><button (click)="gotoButton()">lets go to create booking</button></section>
     
   